export default __webpack_public_path__ + "static/diptheria-a91d080dfc410ff968b9bd516545b147.png";